import HistoryComponentEhss from '@components/HistoryComponentEhss';
import ConfigService from '@services/global/Config';
import ProcessManagementService from '@services/ProcessManagement';
import NotificationComponent from '@src/helpers/_showNotifications';
import { Button, Row } from 'antd';
import React from 'react';

import Page from '../components/Page';
import I18n from '../i18n';
import { LocalStorageKeys } from './App';

interface ITicketDetailsEHSSStateType {
  historyData: any;
  isLoading: boolean;
  extraFields?: any;
};

export default class TicketDetailsEHSS extends React.Component<any, ITicketDetailsEHSSStateType> {

  private idUnit: string = "";
  private _configService: ConfigService = new ConfigService();
  private _ticketEvent: ProcessManagementService = new ProcessManagementService();
  private ticketId = this.props.match.params.id;

  constructor(props: any) {
    super(props);
    this.idUnit = String(localStorage.getItem(LocalStorageKeys.ACTIVE_UNIT_ID))

    this.state = {
      isLoading: true,
      historyData: [],
    }
  }

   componentDidMount ()  {
     this.getHistory(true);
     this.getConfig();
  }

  getConfig = async () => {
    try {
      const data: any = await this._configService.getGLOBAL();
      this.setState({
        extraFields: data.userFields,
      });
      console.log('EXTRAFIELDS', this.state.extraFields)
    } catch (error) {
      console.warn(error);
      NotificationComponent.Notify('error', I18n.l("form.filter.errors.update"), error);
    }
  };

  getHistory = async (showLoading: boolean) => {
    this.setState({ isLoading: showLoading });
    try {
      const data = await this._ticketEvent.getGLOBAL(this.ticketId, true);

      this.setState({
        isLoading: false,
        historyData: data,
      });
    } catch (error) {
      console.warn(error);
      this.setState({
        isLoading: false,
      });
    }
  };

  updateHistoryData() {
    this.getHistory(true);
  }

  render() {
    const { isLoading } = this.state;
    return (
      <Page>
        {isLoading && (
          <p>{I18n.l('common.loadingData')}</p>
        )}
        {!isLoading && (
          <Row className="goepik-component-padding">
            <Button size="large"
              onClick={() => this.updateHistoryData()}
              className={"goepik-btn-border-main"}>
              {I18n.l('history.updateHistory')}
            </Button>
            <Row className="goepik-medium-top-margin">
              <HistoryComponentEhss
                registers={this.state.historyData.items}
                extralfield={this.state.extraFields}
              />
            </Row>
          </Row>
        )}
      </Page>
    );
  }
}
